 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		1: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vendors~intl-relativetimeformat~polyfills","2":"lang_af","3":"lang_ar","4":"lang_be","5":"lang_bg","6":"lang_bs","7":"lang_ca","8":"lang_cs","9":"lang_da","10":"lang_de","11":"lang_el","12":"lang_es","13":"lang_et","14":"lang_fi","15":"lang_fil","16":"lang_fr","17":"lang_he","18":"lang_hi","19":"lang_hr","20":"lang_hu","21":"lang_id","22":"lang_is","23":"lang_it","24":"lang_ja","25":"lang_ka","26":"lang_kk","27":"lang_ko","28":"lang_ky","29":"lang_lt","30":"lang_lv","31":"lang_nl","32":"lang_no","33":"lang_pa","34":"lang_pl","35":"lang_pt","36":"lang_pt_br","37":"lang_ro","38":"lang_ru","39":"lang_sk","40":"lang_sl","41":"lang_sq","42":"lang_sr","43":"lang_sr_me","44":"lang_sv","45":"lang_sw","46":"lang_th","47":"lang_tr","48":"lang_tw","49":"lang_uk","50":"lang_ur","51":"lang_uz","52":"lang_vi","53":"lang_zh_cn","54":"lang_zh_tw","55":"locale_ak","56":"locale_ar","57":"locale_be","58":"locale_bg","59":"locale_bs","60":"locale_ca","61":"locale_cs","62":"locale_da","63":"locale_de","64":"locale_el","65":"locale_en","66":"locale_es","67":"locale_et","68":"locale_fi","69":"locale_fil","70":"locale_fr","71":"locale_he","72":"locale_hi","73":"locale_hr","74":"locale_hu","75":"locale_id","76":"locale_is","77":"locale_it","78":"locale_ja","79":"locale_ka","80":"locale_kk","81":"locale_ko","82":"locale_ky","83":"locale_lt","84":"locale_lv","85":"locale_nl","86":"locale_pa","87":"locale_pl","88":"locale_pt","89":"locale_ro","90":"locale_ru","91":"locale_sk","92":"locale_sl","93":"locale_sq","94":"locale_sr","95":"locale_sr_cyrl_me","96":"locale_sv","97":"locale_sw","98":"locale_th","99":"locale_tr","100":"locale_uk","101":"locale_ur","102":"locale_uz","103":"locale_vi","104":"locale_zh","105":"loclae_af","106":"polyfills","107":"pubnub","111":"vendors~polyfills","112":"vendors~pubnub"}[chunkId]||chunkId) + "." + {"0":"db48322d0fc5f6522bc0","2":"26ca4633ad1bcf1288be","3":"37121664cf0f30b09616","4":"417e90417d8bcc1a3956","5":"ca26b4cae2aa655ed1d2","6":"f17f8d97fa632125656a","7":"fe760ce5528a5102cf4a","8":"b2b7232261e04e87c9b6","9":"9a9bf1e533255adfdd05","10":"1017e20867412340eb4e","11":"6ebbbe0c7fc08b64691d","12":"53dd27fe89af10b2d893","13":"1d816470d352b353e3ac","14":"5e4c7ee11e4adf4d35b9","15":"6975dbdef411be9808ee","16":"fa52466e4cdc103acdb7","17":"a00e6fe24ae83c8073a7","18":"cdbed2e3fc94e7fd2c60","19":"6178879984eda3522969","20":"f0c15577fd36df403c44","21":"ccb5acc64f34824dafe7","22":"48bdc32f1bf821a970cf","23":"3c0c54fee6538350dccb","24":"8ac823e31d6762fc3bad","25":"b98b70e5efe200085ab0","26":"96dae89d627d763677e3","27":"a162035c547d1d7cf14a","28":"4cd1dda44d769f566375","29":"e2e0c84bbed056bf28e0","30":"aae99a51b9fa663e9219","31":"a7c521e09dd109e579eb","32":"eac7d0ce0ec3b441ffa6","33":"2fe841ae9f59305247ed","34":"8070026665699f5b3998","35":"68ef581ee0be9ddf32e0","36":"6e826c9dc9dd60d6d380","37":"50747cf7ff8ee3bb8ded","38":"53fbe3d025f0130ec77b","39":"a97d1b43b458dfca9df0","40":"708fd768463bec74640a","41":"c096547b2ac44efb7299","42":"5b3f7fa4505b4eccbf96","43":"29c6160e1b29d210beb3","44":"943eae09e3fd0a0f6975","45":"60aad9d91bc11e214e6b","46":"428560cad65cf5248d4c","47":"8bb2c7c3d63b574ec91e","48":"5f6056860737214de6c6","49":"ca2a2246e94683d7b001","50":"8bec4b03f0efa6ca95e0","51":"fe369cf2d1af50c8697e","52":"a38cde8ea839ffb5a70b","53":"8f373cfc19c0e2e64d54","54":"44c4b35b06a9d04720f1","55":"5456b0a9b6b8e8046c3b","56":"e7a93469959a40d530ac","57":"3b61f5a3cf1851540ac5","58":"608dd8badc97476a941b","59":"76e079cbc823a4384250","60":"4e75ba0ee18d28929813","61":"5b8b0704ec2cac9a6e5e","62":"a6bd10fd166b45f14b0a","63":"6b7ea7a5bdcd11bb645d","64":"d3783964bf1f0bb5ce86","65":"09ce4f302d57ea30b146","66":"ac16b1788802d10f9418","67":"942ecd6f71997982e56c","68":"1a31171a153ab190fdb1","69":"fe62fa16a132d7d7dd86","70":"8837c97a6a84ac030803","71":"d02f3176289d303d2b65","72":"a40a0859c8f7e9be79ea","73":"b47d61ee60c46ff813b5","74":"05b38a960dc35694dfdb","75":"621381792e3ccdc12cea","76":"9fdb2eb81ab1b914790a","77":"5426324128aac5fed582","78":"5c91f810b1023529ed52","79":"d9a07f83289216037272","80":"10c0b44495ca2fdc87be","81":"3812038dcc9d2cd40f59","82":"ccc494ed3ce6241f5da5","83":"e1ad1bc72f0f2f600a41","84":"40f82233254c2f2e3ca8","85":"5e5a43327534d8a21101","86":"32a2a703d24406966ab0","87":"ce8a720608142ec1711e","88":"68f6311a2d7471399d7d","89":"43b22a6ca40cc3725fa6","90":"d8677296341a7f9c7c60","91":"e25919564c5e6228732f","92":"78f31151c9b0a4bcc985","93":"75d43f32f9eabcc694ab","94":"8c083ae069779a6b6dfa","95":"9626f396beabfe62347e","96":"07c088c2152124f2bf71","97":"180a6a1b81ccf5553199","98":"201ebebb5438cf360c11","99":"9c28867d0ce8ad05ef9c","100":"eaa655765809ecc6f59f","101":"a8ae2702e2f86dcbfceb","102":"9162d492f873e0000507","103":"3f1d90e33b240522706e","104":"e95a8652404f1da263af","105":"fa19523b7a1abc569d71","106":"064702b8b2b11834eacf","107":"48d4a52c86039a536d7e","111":"a1a44093da0c8b9c6978","112":"7d30b4204e2cc2d20cd1"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn.kustomerapp.com/chat-web/release-v0.1.206/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["kustomer_chat_webpackJsonp"] = window["kustomer_chat_webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 94);
